<script>
    import { onMount, onDestroy } from "svelte";
    import * as api from "../utiles/api";
    import { push } from "svelte-spa-router";
    import Btm from "../components/Btm.svelte";
    import * as store from "../stores/store";
    import { asListState } from "../stores/store";
    import { get } from "svelte/store";

    let listState = get(asListState);
    let isFirstLoad = true;
    let savedPage = listState.currentPage || 1;
    let savedScrollTop = listState.scrollTop || 0;
    let listContainer;

    let pageSize = 10; // 한 번에 로드할 데이터 개수
    let currentPage = 0; // 현재 페이지
    let currentList = [];
    let dataList = [];

    let selectedStatus = listState.selectedStatus;
    let searchType = listState.searchType;
    let searchKeyword = listState.searchKeyword;

    let activeStatus = listState.activeStatus;
    let activeSearchType = listState.activeSearchType;
    let activeKeyword = listState.activeKeyword;

    function getLocalDateStr(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    }

    const today = new Date();
    const threeMonthsAgo = new Date();
    threeMonthsAgo.setMonth(today.getMonth() - 3);

    let startDate = listState.startDate || getLocalDateStr(threeMonthsAgo);
    let endDate = listState.endDate || getLocalDateStr(today);
    let activeStartDate = listState.activeStartDate || getLocalDateStr(threeMonthsAgo);
    let activeEndDate = listState.activeEndDate || getLocalDateStr(today);

    let filteredDataList = [];

    let isSearchHidden = listState.isSearchHidden;

    $: {
        asListState.update(state => ({
            ...state,
            selectedStatus, searchType, searchKeyword,
            startDate, endDate,
            activeStatus, activeSearchType, activeKeyword,
            activeStartDate, activeEndDate,
            isSearchHidden,
            currentPage
        }));
    }

    let interval;

    function applySearch() {
        activeStatus = selectedStatus;
        activeSearchType = searchType;
        activeKeyword = searchKeyword;
        activeStartDate = startDate;
        activeEndDate = endDate;
        
        isFirstLoad = false;
        savedPage = 0;
        savedScrollTop = 0;
        
        if (listContainer) {
            listContainer.scrollTop = 0;
        }

        asListState.update(state => ({
            ...state,
            scrollTop: 0,
            currentPage: 0
        }));
        
        getData();
    }

    function toggleSearch() {
        isSearchHidden = !isSearchHidden;
    }

    $: {
        if (dataList) {
            filteredDataList = dataList.filter((data) => {
                let statusMatch = false;
                if (activeStatus === "0") {
                    statusMatch = true;
                } else if (activeStatus === "5") {
                    statusMatch = ["5", "6", "7", "8", "9"].includes(String(data.status));
                } else {
                    statusMatch = String(data.status) === String(activeStatus);
                }
                if (!statusMatch) return false;

                if (!activeKeyword.trim()) return true;

                let keywordMatch = false;
                let keyword = activeKeyword.trim().toLowerCase();

                const includesSafe = (val) =>
                    val && String(val).toLowerCase().includes(keyword);

                if (activeSearchType === "all") {
                    keywordMatch =
                        includesSafe(data.item_name) ||
                        includesSafe(data.cus_name) ||
                        includesSafe(data.addr1) ||
                        includesSafe(data.addr2);
                } else if (activeSearchType === "item_name") {
                    keywordMatch = includesSafe(data.item_name);
                } else if (activeSearchType === "cus_name") {
                    keywordMatch = includesSafe(data.cus_name);
                } else if (activeSearchType === "address") {
                    keywordMatch =
                        includesSafe(data.addr1) || includesSafe(data.addr2);
                }

                return keywordMatch;
            });

            if (isFirstLoad && savedPage > 0) {
                // Restore saved page items
                currentList = filteredDataList.slice(0, savedPage * pageSize);
                currentPage = savedPage;
                isFirstLoad = false;
                
                // Restore scroll after DOM updates
                setTimeout(() => {
                    if (listContainer) {
                        listContainer.scrollTop = savedScrollTop;
                    }
                }, 100);
            } else {
                currentPage = 0;
                currentList = [];
                loadMore();
            }
        }
    }

    onMount(() => {
        getData();

        interval = setInterval(getData, 500000);
    });

    onDestroy(() => {
        clearInterval(interval);
    });

    async function getData() {
        const response = await api.get(
            `/as/mobile?keyword=&page=1&status=${activeStatus}&startDate=${activeStartDate}&endDate=${activeEndDate}&cate=&usePageNavy=false`,
        );

        console.log(response);

        if (response != null) {
            if (JSON.stringify(response.data) !== JSON.stringify(dataList)) {
                dataList = response.data;
            }
        }
    }

    function loadMore() {
        if (!filteredDataList) return;
        const start = currentPage * pageSize;
        const end = start + pageSize;

        currentList = [...currentList, ...filteredDataList.slice(start, end)];
        currentPage++;
    }

    function handleScroll(event) {
        const { scrollTop, scrollHeight, clientHeight } = event.target;
        asListState.update(state => ({ ...state, scrollTop }));

        if (scrollTop + clientHeight >= scrollHeight - 10) {
            if (currentList.length < filteredDataList.length) {
                loadMore();
            }
        }
    }

    function formatPhoneNumber(num) {
        if (!num) return "";

        const digits = String(num).replace(/\D/g, "");

        if (digits.length === 10) {
            // 10자리: 3-3-4
            if (digits.startsWith("02")) {
                return digits.replace(/(\d{2})(\d{4})(\d{4})/, "$1-$2-$3");
            }
            return digits.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
        } else if (digits.length === 11) {
            // 11자리: 3-4-4
            return digits.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3");
        } else {
            // 그 외는 그대로 출력
            return num;
        }
    }
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<!-- svelte-ignore a11y-missing-attribute -->
<div class="main-body custom-theme">
    <div class="main-content">
        <header class="as-header">
            <div class="as-header-top">
                <h1 class="as-page-title">A/S 현황</h1>
                <div class="as-header-right">
                    <div class="as-list-info">
                        총 {filteredDataList.length}건
                    </div>
                    <button class="as-toggle-btn" on:click={toggleSearch}>
                        <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                        >
                            {#if isSearchHidden}
                                <path d="M6 9l6 6 6-6" />
                            {:else}
                                <path d="M18 15l-6-6-6 6" />
                            {/if}
                        </svg>
                    </button>
                </div>
            </div>
            <div class="as-search-wrapper" class:hidden={isSearchHidden}>
                <div class="as-search-row">
                    <select bind:value={selectedStatus} class="as-select">
                        <option value="1">접수완료</option>
                        <option value="2">배정완료</option>
                        <option value="3">작업중</option>
                        <option value="4">작업완료</option>
                        <option value="5">취소</option>
                    </select>
                </div>
                <div class="as-search-row">
                    <input
                        type="date"
                        bind:value={startDate}
                        class="as-search-input as-date-input"
                    />
                    <span class="as-date-separator">~</span>
                    <input
                        type="date"
                        bind:value={endDate}
                        class="as-search-input as-date-input"
                    />
                </div>
                <div class="as-search-row">
                    <select
                        bind:value={searchType}
                        class="as-select as-select-type"
                    >
                        <option value="all">전체</option>
                        <option value="item_name">제품명</option>
                        <option value="cus_name">고객/업체</option>
                        <option value="address">주소</option>
                    </select>
                    <input
                        type="text"
                        bind:value={searchKeyword}
                        on:keyup={(e) => e.key === "Enter" && applySearch()}
                        placeholder="검색어를 입력하세요"
                        class="as-search-input"
                    />
                </div>
                <button class="as-search-btn" on:click={applySearch}>
                    검색
                </button>
            </div>
        </header>

        <div class="as-list-container scroll-custom" on:scroll={handleScroll} bind:this={listContainer}>
            {#if currentList && currentList.length > 0}
                {#each currentList as data, index}
                    <div class="as-card-item">
                        <div class="as-card-header">
                            <span class="as-label-sm">접수시간</span>
                            <span class="as-time-val">{data.created_at}</span>
                            {#if data.status == 1 && data.transfer === "Y"}
                                <span class="as-badge as-highlight">배정 요청</span>
                            {/if}
                        </div>

                        <div class="as-card-body">
                            <div class="as-info-row as-main-info">
                                <span class="as-label">접수처</span>
                                <span class="as-value">
                                    {data.cus_name?.split("<br>")[0] || ""}
                                </span>
                            </div>

                            <div class="as-info-row as-main-info">
                                <span class="as-label">수리처</span>
                                <span class="as-value">
                                    {data.cus_name?.split("<br>")[1] || ""}
                                </span>
                            </div>

                            <div class="as-info-divider"></div>

                            <div class="as-info-row">
                                <span class="as-label">제품명</span>
                                <span class="as-value">{data.item_name}</span>
                            </div>

                            <div class="as-info-row">
                                <span class="as-label">주소</span>
                                <span class="as-value as-address">
                                    {data.addr1}
                                    {data.addr2}
                                </span>
                            </div>

                            <div class="as-info-row">
                                <span class="as-label">연락처</span>
                                <a
                                    href="tel:{data.phone}"
                                    class="as-value as-tel"
                                >
                                    {formatPhoneNumber(data.phone)}
                                </a>
                            </div>

                            <div class="as-symptom-section">
                                <span class="as-label">고객 증상</span>
                                <div class="as-symptom-box">
                                    <p class="as-symptom-text">
                                        {data.symptom_cus}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div class="as-card-footer">
                            <button
                                class="as-action-btn"
                                on:click={() => {
                                    // 선택된 AS 정보 스토어에 저장
                                    store.selectedAs.set(data);

                                    if (data.status != 1) {
                                        push(`/AsDetail/${data.as_id}`);
                                    } else {
                                        if (
                                            data.as_cmpn_id ==
                                                get(store.accountInfo).cmpn_id &&
                                            data.cmpn_id !=
                                                get(store.accountInfo).cmpn_id
                                        ) {
                                            push(
                                                `/AsRepair/${data.as_id}/${get(store.accountInfo).cmpn_id}`,
                                            );
                                        } else {
                                            push(`/AsPartner/${data.as_id}`);
                                        }
                                    }
                                }}
                            >
                                {data.status != 1 ? '상세 보기' : '작업 진행'}
                            </button>
                        </div>
                    </div>
                {/each}
            {:else}
                <div class="as-none-data">
                    <img src="../img/ico_data_none.png" alt="No data" />
                    <p>접수 요청 건이 없습니다.</p>
                </div>
            {/if}
        </div>

        <div class="as-floating-container">
            <button class="as-fab-btn" on:click={() => push(`/AsForm`)}>
                <svg
                    class="as-fab-icon"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M12 5V19M5 12H19"
                        stroke="currentColor"
                        stroke-width="3"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg>
                <span>신규 접수</span>
            </button>
        </div>

        <Btm />
    </div>
</div>

<style>
    /* 상위 클래스 .custom-theme를 사용하여 우선순위 강화 */
    .custom-theme.main-body {
        background-color: var(--bg-primary) !important;
        min-height: 100vh;
        padding: 0;
        margin: 0;
    }

    .custom-theme .main-content {
        max-width: 1024px;
        margin: 0 auto;
        position: relative;
        height: 100vh;
        display: flex;
        flex-direction: column;
        background-color: var(--bg-primary);
    }

    /* Header & Tabs */
    .custom-theme .as-header {
        background-color: var(--bg-secondary);
        border-bottom: 1px solid var(--border-color);
        position: sticky;
        top: 0;
        z-index: 10;
        display: flex;
        flex-direction: column;
        transition: all 0.3s ease;
    }
    .custom-theme .as-header-top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px 16px;
        width: 100%;
        box-sizing: border-box;
    }
    .custom-theme .as-search-wrapper {
        padding: 0 16px 16px 16px;
        display: flex;
        flex-direction: column;
        gap: 10px;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        overflow: hidden;
        max-height: 250px;
        opacity: 1;
        width: 100%;
        box-sizing: border-box;
    }
    .custom-theme .as-search-wrapper.hidden {
        max-height: 0;
        padding-top: 0;
        padding-bottom: 0;
        opacity: 0;
        margin: 0;
    }
    .custom-theme .as-search-row {
        display: flex;
        gap: 10px;
        width: 100%;
        align-items: center;
    }
    .custom-theme .as-select {
        margin: 0;
        padding: 0 12px;
        border-radius: 8px;
        border: 1px solid var(--border-color);
        background-color: var(--bg-primary);
        color: var(--text-primary);
        font-size: 14px;
        outline: none;
        flex: 1;
        height: 42px;
        box-sizing: border-box;
        line-height: 40px;
        vertical-align: middle;
    }
    .custom-theme .as-select-type {
        flex: 0 0 110px;
    }
    .custom-theme .as-search-input {
        margin: 0;
        flex: 1;
        padding: 0 12px;
        border-radius: 8px;
        border: 1px solid var(--border-color);
        background-color: var(--bg-primary);
        color: var(--text-primary);
        font-size: 14px;
        outline: none;
        box-sizing: border-box;
        height: 42px;
        line-height: 40px;
        vertical-align: middle;
    }
    .custom-theme .as-date-input {
        text-align: center;
        padding: 0 5px;
    }
    .custom-theme .as-date-separator {
        color: var(--text-secondary);
        font-weight: 600;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 4px;
    }
    .custom-theme .as-search-btn {
        width: 100%;
        padding: 10px 12px;
        background-color: var(--color-primary);
        color: white;
        border: none;
        border-radius: 8px;
        font-size: 15px;
        font-weight: 700;
        cursor: pointer;
        transition: opacity 0.2s;
        height: 42px;
        box-sizing: border-box;
    }
    .custom-theme .as-search-btn:active {
        opacity: 0.8;
    }
    .custom-theme .as-header-right {
        display: flex;
        align-items: center;
        gap: 10px;
    }
    .custom-theme .as-toggle-btn {
        background: none;
        border: none;
        color: var(--text-secondary);
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 4px;
        cursor: pointer;
        border-radius: 4px;
        outline: none;
    }
    .custom-theme .as-toggle-btn:hover {
        background-color: var(--bg-tertiary);
    }
    .custom-theme .as-search-input:focus,
    .custom-theme .as-select:focus {
        border-color: var(--color-primary);
    }
    .custom-theme .as-page-title {
        font-size: 18px;
        font-weight: 800;
        color: var(--text-primary);
        margin: 0;
    }
    .custom-theme .as-list-info {
        font-size: 13px;
        color: var(--text-tertiary);
        font-weight: 600;
    }

    /* List Container */
    .custom-theme .as-list-container {
        flex: 1;
        overflow-y: auto;
        padding: 16px;
        /* 버튼과 하단 바 높이를 고려하여 충분한 여백 추가 */
        padding-bottom: 160px;
    }

    /* AS Card */
    .custom-theme .as-card-item {
        background-color: var(--bg-secondary);
        border-radius: var(--radius-md);
        box-shadow: var(--shadow-sm);
        margin-bottom: 16px;
        overflow: hidden;
        border: 1px solid var(--border-color);
        /* 폰트 확대 시 유연하게 늘어나도록 설정 */
        height: auto;
        min-height: 180px;
        padding-bottom: 8px;
    }

    .custom-theme .as-card-header {
        padding: 10px 16px;
        background-color: var(--bg-tertiary);
        display: flex;
        align-items: center;
        border-bottom: 1px solid var(--border-color);
    }
    .custom-theme .as-time-val {
        font-size: 13px;
        color: var(--text-primary);
        font-weight: 600;
        margin-left: 8px;
        flex: none;
    }
    .custom-theme .as-label-sm {
        font-size: 11px;
        color: var(--text-tertiary);
        flex: none;
    }
    .custom-theme .as-badge {
        margin-left: auto;
        padding: 3px 8px;
        border-radius: 4px;
        font-size: 11px;
        font-weight: 700;
        background-color: var(--bg-primary);
        color: var(--text-secondary);
        border: 1px solid var(--border-color);
    }
    .custom-theme .as-badge.as-highlight {
        background-color: #7c58ff;
        color: white;
        border-color: #7c58ff;
    }

    .custom-theme .as-card-body {
        padding: 14px 16px;
    }
    .custom-theme .as-main-info {
        margin-bottom: 6px;
    }
    .custom-theme .as-main-info .as-value {
        font-size: 16px;
        font-weight: 700;
        color: var(--text-primary);
    }

    .custom-theme .as-info-divider {
        height: 1px;
        background-color: var(--border-color);
        margin: 10px 0;
        opacity: 0.4;
    }

    .custom-theme .as-info-row {
        display: flex;
        margin-bottom: 5px;
        font-size: 14px;
        align-items: flex-start;
    }
    .custom-theme .as-label {
        width: 70px;
        color: var(--text-tertiary);
        font-weight: 500;
        font-size: 13px;
        flex-shrink: 0;
    }
    .custom-theme .as-value {
        flex: 1;
        color: var(--text-primary);
        word-break: break-all;
    }
    .custom-theme .as-address {
        line-height: 1.4;
    }
    .custom-theme .as-tel {
        color: var(--color-primary);
        text-decoration: underline;
        font-weight: 600;
    }

    .custom-theme .as-symptom-section {
        margin-top: 12px;
    }
    .custom-theme .as-symptom-box {
        margin-top: 6px;
        padding: 12px;
        background-color: var(--bg-tertiary);
        border-radius: 6px;
        border: 1px solid var(--border-color);
    }

    .custom-theme .as-symptom-text {
        font-size: 13px;
        color: var(--text-secondary);
        white-space: pre-wrap;
        word-break: break-all;
        margin: 0;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        line-height: 1.5;
    }

    .custom-theme .as-card-footer {
        padding: 0 16px 16px;
    }
    .custom-theme .as-action-btn {
        width: 100%;
        padding: 12px;
        background-color: var(--bg-tertiary);
        color: var(--text-primary);
        border: 1px solid var(--border-color);
        border-radius: 8px;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.2s;
    }
    .custom-theme .as-action-btn:hover {
        background-color: var(--color-primary);
        color: white;
    }

    /* Floating Action Button (FAB) */
    .custom-theme .as-floating-container {
        position: fixed;
        bottom: 85px; /* 하단 바 위에 적절히 위치 */
        right: 20px;
        z-index: 100;
        pointer-events: none;
    }
    .custom-theme .as-fab-btn {
        pointer-events: auto;
        display: flex;
        align-items: center;
        justify-content: center; /* 중앙 정렬 추가 */
        gap: 10px; /* 간격 살짝 넓힘 */
        padding: 14px 24px;
        background: linear-gradient(135deg, var(--color-primary), #2563eb);
        color: white;
        border: none;
        border-radius: 100px;
        font-size: 16px;
        font-weight: 700;
        box-shadow: 0 8px 20px rgba(59, 130, 246, 0.4);
        cursor: pointer;
        transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    }

    .custom-theme .as-fab-icon {
        width: 18px;
        height: 18px;
        display: block;
    }

    /* 다크모드에서는 그림자를 더 깊게 */
    :global([data-theme="dark"]) .custom-theme .as-fab-btn {
        box-shadow: 0 8px 25px rgba(0, 0, 0, 0.5);
    }

    .custom-theme .as-none-data {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 60vh;
        color: var(--text-tertiary);
    }
</style>
